import { AboutUsDefault } from 'src/components/features';

const AboutUs = () => <AboutUsDefault />;

export default AboutUs;
